import axios from 'axios';

function Config() {
  axios.defaults.baseURL = 'http://127.0.0.1:8880';
}

export default Config;
